// src/components/gavion/integrations/api/errorMessage.ts
import { M365ApiError } from "./types";

type T = (key: string, opts?: Record<string, unknown>) => string;
export function errorMessage(translate: T, e: unknown): string {
  const code = e instanceof M365ApiError ? e.code : "unknown";
  const emails =
    e instanceof M365ApiError && Array.isArray(e.details?.suppressed)
      ? (e.details!.suppressed as string[]).join(", ")
      : "";
  return translate(`gavion.integrations.errors.${code}`, {
    emails,
    _: translate("gavion.integrations.errors.unknown"),
  });
}
